import Cookies from "js-cookie";

// The PHP login response has no `user` object; it returns { token,
// business:[{ID(=userID), groupName, groupPriority, businessToken, ... }],
// privateName, lastName, phone }. Some screens read userData.user.role/.id, so
// bridge that here so role-gated UI keeps working under the PHP backend.

// PHP group priority → client role (0/1 owner, 2 manager, 3 host, else least-privileged).
export function roleFromBusiness(biz) {
    const p = Number(biz?.groupPriority);
    if (Number.isFinite(p)) {
        if (p <= 1) return "owner";
        if (p === 2) return "manager";
        if (p === 3) return "host";
    }
    return "waiter";
}

// Enrich the PHP login `data` with user:{id,role,name}.
export function normalizeSession(data) {
    const biz = (data && Array.isArray(data.business) && data.business[0]) || {};
    return {
        ...data,
        user: {
            id: biz.ID || null,
            role: roleFromBusiness(biz),
            name: [data && data.privateName, data && data.lastName].filter(Boolean).join(" "),
        },
    };
}

export function getCurrentUser() {
    try {
        const raw = Cookies.get("userData");
        return raw ? JSON.parse(raw).user || null : null;
    } catch {
        return null;
    }
}

export default { normalizeSession, roleFromBusiness, getCurrentUser };
